<template>
    <div class="block_screen">
        <img class="img-center" src="assets/backup_screens/scr3.png" alt="">
        <a @click.prevent="changeScreen(3)" class="flash_buttons br-btn2-1" href=""></a>
        <a @click.prevent="changeScreen(29)" class="flash_buttons br-btn2-2" href=""></a>
        <a @click.prevent="changeScreen(107)" class="flash_buttons br-btn2-3" href=""></a>
        <a class="flash_buttons" href=""></a>
      <div class="btn_left">
        <a href="" @click.prevent="changeScreen(90)"
           class="btn btn_orange">Zurück</a>
      </div>
    </div>
</template>
<script>
    import {mapMutations} from 'vuex'
    import $ from 'jquery'
    export default {
        mounted() {
            $.each($('.flash_buttons'), function(i, el) {
                setTimeout(function() {
                    $(el).toggleClass("active");
                    $(el).prev().toggleClass("active");
                }, 1000 + (i * 500));

            });
        },
        methods: {
            ...mapMutations({
                changeScreen: 'setScreen' // map `this.add()` to `this.$store.commit('increment')`
            })
        },
    };
</script>
<style type="text/css">
    .br-btn2-1 {
      position: absolute;
      top: 188px;
      left: 257px;
      width: 570px;
      height: 70px;
      z-index: 7;
    }
    .br-btn2-2 {
      position: absolute;
      top: 258px;
      left: 257px;
      width: 570px;
      height: 70px;
      z-index: 7;
    }
    .br-btn2-3 {
      position: absolute;
      top: 328px;
      left: 257px;
      width: 570px;
      height: 70px;
      z-index: 7;
    }
</style>
